import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import parse from 'html-react-parser';
import GLOBAL_CONFIG from '../../config/config';
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle } from '../../modules/helpers';
import { NavLink } from 'react-router-dom';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
class End extends Component {

  constructor(props) {
    super(props)

    // to check if the device is a mobile or not 
    this.state = {
      isMobile: false
    }

    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    const { t } = this.props;
    //Remove main loader
    mainLoaderToggle('hide');

    //Virtual page
    appGoogleTracking.dataLayerPush({
      'customEvent': {
        'event': 'virtual-page',
        'virtualUri': GLOBAL_CONFIG.Route.end,
        'pageTitle': t('Meta.title')
      }
    });

    window.addEventListener("resize", this.resize);
    this.resize();
  }

  componentWillUnmount() {
    //Show mainloader
    mainLoaderToggle('show');
  }

  resize() {
    // set isMobile to true if the device is a mobile and false otherwise 
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  render() {

    const { t } = this.props;

    return (
      <div className="s-card-container s-content-end end">
        {/* <h1>{parse(t('Page.End.title'))}</h1> */}
        <TitleContent
          heading={parse(t('Page.End.title'))}
          subheading={t('Page.End.paragraph') && parse(t('Page.End.paragraph'))}
        />
        {this.DisplayCards(t)}
      </div>
    );
  }




  CardSection() {
    return (

      <div className="end-element">
        
        <div className="end-element__item">
          <img src="/resources/images/edeka/end1.png" />
          <div className="end-element__copy">
            <h3 className="end-element__copy__title">Aufregend dunkel …</h3>
            <p className="good-headline-pro">
              Entdecke die Vielfalt von zarter dunkler Alpenmilchschokolade. Diese sechs aufregenden Milka Dark Milk Sorten warten darauf, von dir probiert zu werden:
              Milka Darkmilk Dunkle Alpenmilch, Kakao Splitter, Gesalzenes Karamell, Himbeere und Haselnuss. Und jetzt ganz neu auch in der Sorte Nougat-Crème.
            </p>
            <a href="https://fcmilka.de/account" target="_blank"
              data-event="join_now"
              data-category="End Page"
              data-action="Go to Page"
              data-label="ENG_EP_OTHER"
              onClick={appGoogleTracking.processEventCTANavLink}>
              <button className="btn__container btn--secondary-lilac">
                {' '}
                Jetzt entdecken{' '}
              </button>
            </a>
          </div>
        </div>

        <div className="end-element__item">
          <img src="/resources/images/edeka/end2.png" />
          <div className="end-element__copy">
            <h3 className="end-element__copy__title">Milka zum Snacken</h3>
            <p className="good-headline-pro">
              Milka Favourites ist dein perfekter Begleiter für gesellige Runden. Hier ist von fruchtigem Erdbeer- und Cheesecake, Karamell und Haselnuss, knusprigen Waffeln und leckeren Milka Oreos sowie klassischen Milkinis für jeden Geschmack etwas dabei.
            </p>
            {this.props.promotionCampaign !== 'alle' ? (
              <a href="https://www.milka.de/shop" target="_blank"
                data-event="join_now"
                data-category="End Page"
                data-action="Go to Page"
                data-label="ENG_EP_OTHER"
                onClick={appGoogleTracking.processEventCTANavLink}>
                <button className="btn__container btn--secondary-lilac good-headline-pro">
                  {' '}
                  ZUM MILKA SHOP{' '}
                </button>
              </a>
            ) : (
            <a href="https://www.milka.de/shop" target="_blank"
              data-event="learn_more"
              data-category="End Page"
              data-action="Go to Page"
              data-label="ENG_EP_OTHER"
              onClick={appGoogleTracking.processEventCTANavLink}>
              <button className="btn__container btn--secondary-lilac good-headline-pro">
                {' '}
                    Jetzt entdecken{' '}
              </button>
            </a>)}
            
          </div>
        </div>

        <div className="end-element__item">
          <img src="/resources/images/edeka/end3.png" />
          <div className="end-element__copy">
            <h3 className="end-element__copy__title">Nachhaltigkeit bei Milka</h3>
            <p className="good-headline-pro">
              Wusstest du, dass Milka mit Cacao Life ein globales Kakao-Nachhaltigkeitsprogramm hat? Und dass Milka sich gegen Kinderarbeit stark macht? Denn Milka will die Lebens- und Arbeitsbedingungen von Kakaobauern und ihren Familien langfristig verbessern.
            </p>
            {this.props.promotionCampaign !== 'alle' ? (
              <a href="https://www.milka.de/neues" target="_blank"
                data-event="learn_more"
                data-category="End Page"
                data-action="Go to Page"
                data-label="ENG_EP_OTHER"
                onClick={appGoogleTracking.processEventCTANavLink}>
                <button className="btn__container btn--secondary-lilac good-headline-pro">
                  {' '}
                  NEUES ENTDECKEN{' '}
                </button>
              </a>
            ) : (<a href="https://fcmilka.de/account" target="_blank"
              data-event="discover_now"
              data-category="End Page"
              data-action="Go to Page"
              data-label="ENG_EP_OTHER"
              onClick={appGoogleTracking.processEventCTANavLink}>
              <button className="btn__container btn--secondary-lilac">
                {' '}
                  MEHR ERFAHREN{' '}
              </button>
            </a>)}
            
          </div>
        </div>
      </div>

    )
  }

  
  DisplayCards(t) {
    const boxs = t("Page.End.boxs", { returnObjects: true });
    return (
      <div className="s-card-container">
        {
          boxs.map(({ img, platzhalter, title, copy, button, tag }) => (
            <div className="s-card" key={title}>
              <img src={img} alt="" />
              {platzhalter ? (<img src={platzhalter} alt="" className="platzhalter" />) : null}
              <div className="s-card__copy">
                <h3>{parse(title)}</h3>
                <p style={{ fontFamily:'Good Headline Pro'}}>{parse(copy)}</p>
                <a href={button.href} target="_blank"
                  data-event={tag.dataEvent}
                  data-category={tag.dataCategory}
                  data-action={tag.dataAction}
                  data-label={tag.dataLabel}
                  onClick={appGoogleTracking.processEventCTANavLink}
                >
                  <div className="btn__container btn--secondary-lilac btn--hover">
                    <span className="btn__text"> {button.text} </span>
                  </div>
                </a>
              </div>
            </div>
          ))
        }
        <div className="s-card" >
              <img src='/resources/images/gluecksrad/end2.png' alt="" />
              <div className="s-card__copy">
                <h3>Milka online bestellen</h3>
                <p style={{ fontFamily:'Good Headline Pro'}}>Wusstest du, dass du Milka Produkte auch online bestellen kannst?</p>
                <div className='shops'>
                  <a><img src='/resources/images/gluecksrad/gurkel.png' alt="" /></a>
                  <a><img src='/resources/images/gluecksrad/alfies.png' alt="" /></a>
                  <a><img src='/resources/images/gluecksrad/foodora.png' alt="" /></a>
                </div>
              </div>
            </div>
      </div>
    );
  }
}

export default withTranslation()(End);